module.exports = __webpack_public_path__ + "img/image2.6030c49b.jpg";